import React from 'react';
import { Box, Typography, Grid, Card, CardMedia, CardContent, Chip, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
// import LevIcon from '@mui/icons-material/School';
import LevIcon from '@mui/icons-material/ContentCopy';
import TimeIcon from '@mui/icons-material/AccessTime';
import { formatDuration2 } from "../../utils/formatDuration";

function MainSection({ content }) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: content.length === 0 ? 'center' : 'flex-start',
                alignItems: 'center',
                minHeight: 'auto', // Adjust height for responsiveness
            }}
        >
            {content.length === 0 ? (
                <Typography
                    variant="body1"
                    sx={{ textAlign: 'center', color: 'gray', fontStyle: 'italic' }}
                >
                    No content found. Try adjusting the filters.
                </Typography>
            ) : (
                <Grid container spacing={{ xs: 0, sm: 2, md: 3 }} sx={{ width: '100%', mx: 'auto' }}>
                    {content.map((data) => (
                        <Grid item xs={12} sm={6} md={4} key={data.id}
                            sx={{ mb: { xs: 2, sm: 2 } }}>
                            <Link to={`/${data.type}/${data.slug}`} style={{ textDecoration: 'none' }}>
                                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', }}>
                                    {/* Image */}
                                    <CardMedia
                                        component="img"
                                        image={data.image}
                                        alt={data.title}
                                        sx={{
                                            aspectRatio: '21 / 9',
                                            objectFit: 'cover',
                                        }}
                                    />

                                    {/* Details */}
                                    <CardContent>
                                        <Typography
                                            variant="subtitle1"
                                            sx={{
                                                fontWeight: 'bold',
                                                mb: 1,
                                                display: '-webkit-box',
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                WebkitLineClamp: 2,
                                                lineHeight: '1.2rem',
                                                maxHeight: '2.4rem',
                                            }}
                                        >
                                            {data.title}
                                        </Typography>

                                        {/* Chips */}
                                        <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                                            <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                                                <Chip
                                                    label={data.type}
                                                    color={
                                                        data.type == 'course'
                                                            ? 'primary'
                                                            : 'secondary'
                                                    }
                                                    size="small"
                                                />
                                            </Stack>
                                            <Chip label={data.domain} size="small" />
                                        </Stack>

                                        {/* Icon Row */}
                                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                                            <Box display="flex" alignItems="center">
                                                <LevIcon fontSize="small" color='#ff0' sx={{ mr: 0.8 }} />
                                                <Typography variant="body2">{data.level}</Typography>
                                            </Box>
                                            {data.duration > 60 && (
                                                <Box display="flex" alignItems="center" sx={{ justifyContent: 'flex-end' }}>
                                                    <TimeIcon fontSize="small" sx={{ mr: 0.8 }} />
                                                    <Typography variant="body2">{formatDuration2(data.duration)}</Typography>
                                                </Box>
                                            )}
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </Link>
                        </Grid>
                    ))}
                </Grid>
            )}
        </Box>
    );
}

export default MainSection;
